import React from 'react'
import cn from 'classnames'

import './LinkButton.scss'

export const LinkButton = ({
  label,
  color = '',
  link,
  inNewTab
}) => {
  return (
    // eslint-disable-next-line
    <a
      href={ link }
      className={cn( 'link-button', color )}
      target={ inNewTab ? '_blank' : '' }
      rel={ inNewTab ? 'noopener noreferrer' : '' }
    >
      { label }
    </a>
  )
}